import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import React from 'react';
export var ObjectCounter = function (_a) {
    var segments = _a.segments;
    return (React.createElement(Stack, null, segments.map(function (_a) {
        var count = _a.count, limit = _a.limit, label = _a.label;
        return (React.createElement(Stack, { key: label, direction: "row", alignItems: "center", justifyContent: "space-between", sx: { width: '180px' } },
            React.createElement(LinearProgress, { variant: "determinate", value: count * 100 / limit, sx: { width: '100px', height: '8px' } }),
            React.createElement("span", null, count + "/" + limit),
            label && React.createElement("span", null, label)));
    })));
};
export default ObjectCounter;
//# sourceMappingURL=ObjectCounter.js.map